/* ═══════════════════════════════════════════════════
   Step 2 — Cohort Selection
   ═══════════════════════════════════════════════════ */
import React from 'react';
import { FifaPlayerCard, LUMINA_CREATORS } from '../FifaPlayerCard';
import { ChevronLeft, ChevronRight, ArrowRight } from 'lucide-react';
import { T, BG, CARD, BORDER } from './constants';

export default function Step2Cohort({ selectedCreators, setSelectedCreators, scrollRef, onProceed }) {
  const scroll = (dir) => scrollRef.current?.scrollBy({ left: dir * 220, behavior: 'smooth' });
  const toggleCreator = (id) => {
    setSelectedCreators(prev => {
      const n = new Set(prev);
      if (n.has(id)) n.delete(id); else n.add(id);
      return n;
    });
  };
  return (
    <div className="space-y-5" data-testid="step-cohort">
      <div className="rounded-xl p-5" style={{ background: CARD, border: `1px solid ${BORDER}` }}>
        <div className="flex items-center justify-between mb-1">
          <h2 className="text-lg font-bold text-white">Your Custom Wave Cohort is Ready</h2>
          <div className="flex gap-2">
            <button onClick={() => setSelectedCreators(new Set(LUMINA_CREATORS.map(c => c.id)))} className="px-3 py-1.5 rounded-lg text-xs font-semibold" style={{ background: `${T}15`, color: T, border: `1px solid ${T}30` }} data-testid="select-all-btn">Select All</button>
            <button onClick={() => setSelectedCreators(new Set())} className="px-3 py-1.5 rounded-lg bg-white/5 text-gray-400 text-xs font-semibold border border-white/10" data-testid="deselect-all-btn">Deselect All</button>
          </div>
        </div>
        <p className="text-xs text-gray-500 mb-4">Showing 16 of 250+ recommended creators matched via Digital DNA.</p>
        <div className="flex gap-2 mb-3">
          <button onClick={() => scroll(-1)} className="p-1.5 rounded-lg text-gray-400 hover:text-white" style={{ background: BG, border: `1px solid ${BORDER}` }}><ChevronLeft className="h-4 w-4" /></button>
          <button onClick={() => scroll(1)} className="p-1.5 rounded-lg text-gray-400 hover:text-white" style={{ background: BG, border: `1px solid ${BORDER}` }}><ChevronRight className="h-4 w-4" /></button>
          <span className="text-xs text-gray-600 flex items-center ml-2">{selectedCreators.size} selected</span>
        </div>
        <div ref={scrollRef} className="flex gap-3 overflow-x-auto no-scrollbar pb-2" data-testid="creator-cohort-grid">
          {LUMINA_CREATORS.map(c => (
            <FifaPlayerCard key={c.id} creator={c} selected={selectedCreators.has(c.id)} onToggle={toggleCreator} />
          ))}
        </div>
      </div>
      <div className="flex justify-center pt-2">
        <button onClick={onProceed} disabled={selectedCreators.size === 0} className="px-8 py-3.5 rounded-xl text-sm font-bold text-black flex items-center gap-2 disabled:opacity-30" style={{ background: T, boxShadow: `0 0 20px ${T}30` }} data-testid="proceed-to-review-btn">
          <ArrowRight className="h-4 w-4" />Proceed to Review & Send
        </button>
      </div>
    </div>
  );
}
